import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const InfoToolTip = ({ tooltip }: { tooltip: string }) => (
	<span data-testid="test-infotooltip">
		<OverlayTrigger
			placement="top"
			overlay={
				<Tooltip
					style={{ whiteSpace: "pre-line" }}
					className={tooltip.length > 200 ? "wide-tooltip" : ""}
				>
					{tooltip}
				</Tooltip>
			}
		>
			<FontAwesomeIcon className="ms-1" icon={faInfoCircle} />
		</OverlayTrigger>
	</span>
);
